export default __webpack_public_path__ + "8495c31.png";